module.exports = __webpack_public_path__ + "static/media/MySql.255b77e2.png";